var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGachaMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 487,
    viewBox: "0 0 370 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1007_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.75 19.48H157.25V29.22H212.75V19.48Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 29.2202H148V38.9602H222V29.2202Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 38.96H138.75V48.7H231.25V38.96Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 38.96H148V48.7H222V38.96Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M240.5 48.7002H129.5V58.4402H240.5V48.7002Z",
    fill: "#87CEEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M129.5 58.4404H120.25V68.1804H129.5V58.4404Z",
    fill: "#87CEEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M249.75 58.4404H240.5V68.1804H249.75V58.4404Z",
    fill: "#87CEEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M111 68.1802H101.75V185.06H111V68.1802Z",
    fill: "#B0D4E8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M268.25 68.1802H259V185.06H268.25V68.1802Z",
    fill: "#5FA8D3"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.25 68.1802H111V185.06H120.25V68.1802Z",
    fill: "#D4E8F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M259 68.1802H249.75V185.06H259V68.1802Z",
    fill: "#4A90C0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M259 185.06H111V194.8H259V185.06Z",
    fill: "#87CEEB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M249.75 194.8H120.25V204.54H249.75V194.8Z",
    fill: "#87CEEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 87.6602H138.75V116.88H166.5V87.6602Z",
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 77.9199H148V87.6599H157.25V77.9199Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 116.88H148V126.62H157.25V116.88Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 87.6602H203.5V116.88H231.25V87.6602Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 77.9199H212.75V87.6599H222V77.9199Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 116.88H212.75V126.62H222V116.88Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.875 126.62H171.125V155.84H198.875V126.62Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.625 116.88H180.375V126.62H189.625V116.88Z",
    fill: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.625 155.84H180.375V165.58H189.625V155.84Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 136.36H129.5V165.58H157.25V136.36Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 126.62H138.75V136.36H148V126.62Z",
    fill: "#5EFF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148 165.58H138.75V175.32H148V165.58Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 136.36H212.75V165.58H240.5V136.36Z",
    fill: "#9370DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 126.62H222V136.36H231.25V126.62Z",
    fill: "#B8A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 165.58H222V175.32H231.25V165.58Z",
    fill: "#6A4DB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 155.84H157.25V175.32H175.75V155.84Z",
    fill: "#FF69B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 146.1H157.25V155.84H166.5V146.1Z",
    fill: "#FF8DC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 204.54H111V214.28H259V204.54Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 214.28H101.75V224.02H268.25V214.28Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 214.28H111V224.02H259V214.28Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 224.02H92.5V233.76H277.5V224.02Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 224.02H101.75V233.76H268.25V224.02Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 233.76H92.5V379.86H277.5V233.76Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 243.5H101.75V370.12H268.25V243.5Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111 233.76H101.75V379.86H111V233.76Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 233.76H259V379.86H268.25V233.76Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 253.24H148V292.2H222V253.24Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75 262.98H157.25V282.46H212.75V262.98Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5 267.85H166.5V277.59H203.5V267.85Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 253.24H148V262.98H222V253.24Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222 282.46H148V292.2H222V282.46Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 311.68H120.25V350.64H175.75V311.68Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5 321.42H129.5V340.9H166.5V321.42Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.25 326.29H138.75V336.03H157.25V326.29Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 311.68H120.25V321.42H175.75V311.68Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75 340.9H120.25V350.64H175.75V340.9Z",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.25 311.68H194.25V360.38H268.25V311.68Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259 321.42H203.5V350.64H259V321.42Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75 331.16H212.75V350.64H249.75V331.16Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.5 311.68H194.25V360.38H203.5V311.68Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75 379.86H83.25V399.34H286.75V379.86Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.5 379.86H92.5V399.34H277.5V379.86Z",
    fill: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 399.34H74V418.82H296V399.34Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75 399.34H83.25V418.82H286.75V399.34Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25 418.82H64.75V438.3H305.25V418.82Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 418.82H74V438.3H296V418.82Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.5 438.3H55.5V457.78H314.5V438.3Z",
    fill: "#6A6A6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.25 438.3H64.75V457.78H305.25V438.3Z",
    fill: "#5A5A5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 448.04H74V457.78H296V448.04Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 262.98H231.25V272.72H240.5V262.98Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.25 267.85H222V277.59H231.25V267.85Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75 267.85H240.5V277.59H249.75V267.85Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.5 272.72H231.25V282.46H240.5V272.72Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1007_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.7981 226.083L56.9749 218.026L54.9606 221.482L68.7838 229.539L70.7981 226.083Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2397 231.553L51.5048 219.467L49.4905 222.923L70.2254 235.009L72.2397 231.553Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6812 237.023L46.0347 220.909L44.0204 224.365L71.6669 240.479L73.6812 237.023Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1228 242.493L40.5646 222.351L38.5503 225.806L73.1085 245.949L75.1228 242.493Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5643 247.963L35.0945 223.792L33.0802 227.248L74.55 251.419L76.5643 247.963Z",
    fill: "#CC3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.55 251.419L33.0802 227.248L31.0659 230.704L72.5357 254.875L74.55 251.419Z",
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9916 256.889L27.6101 228.689L25.5958 232.145L73.9773 260.345L75.9916 256.889Z",
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9773 260.345L25.5958 232.146L21.5673 239.057L69.9487 267.257L73.9773 260.345Z",
    fill: "#FF4444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9487 267.257L21.5673 239.057L19.553 242.513L67.9344 270.713L69.9487 267.257Z",
    fill: "#FF5555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4021 226.952L52.9463 224.938L50.932 228.393L54.3878 230.408L56.4021 226.952Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3878 230.408L47.4762 226.379L45.4619 229.835L52.3736 233.864L54.3878 230.408Z",
    fill: "#FF6666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3736 233.864L42.0061 227.821L39.9918 231.277L50.3593 237.319L52.3736 233.864Z",
    fill: "#FF7777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3593 237.319L36.536 229.262L34.5217 232.718L48.345 240.775L50.3593 237.319Z",
    fill: "#FF8888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8008 242.79L34.5217 232.718L32.5074 236.174L49.7865 246.245L51.8008 242.79Z",
    fill: "#FF9999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5501 251.419L64.1826 245.376L62.1683 248.832L72.5358 254.875L74.5501 251.419Z",
    fill: "#DD3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9916 256.89L65.6241 250.847L63.6099 254.302L73.9773 260.345L75.9916 256.89Z",
    fill: "#DD3333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9773 260.345L67.0657 256.317L63.0371 263.229L69.9487 267.257L73.9773 260.345Z",
    fill: "#CC2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9345 270.713L19.553 242.513L17.5388 245.969L65.9202 274.168L67.9345 270.713Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.4787 268.698L23.0089 244.527L20.9946 247.983L62.4644 272.154L64.4787 268.698Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0228 266.684L26.4647 246.541L24.4504 249.997L59.0086 270.14L61.0228 266.684Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9202 274.168L17.5388 245.968L15.5245 249.424L63.9059 277.624L65.9202 274.168Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9059 277.624L15.5245 249.424L11.4959 256.336L59.8774 284.536L63.9059 277.624Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8774 284.536L11.4959 256.336L9.48163 259.792L57.8631 287.992L59.8774 284.536Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4073 285.977L12.9374 261.806L10.9232 265.261L52.393 289.433L54.4073 285.977Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9371 287.419L14.379 267.276L12.3647 270.732L46.9229 290.874L48.9371 287.419Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4671 288.86L15.8206 272.746L13.8063 276.202L41.4528 292.316L43.4671 288.86Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.997 290.302L17.2621 278.216L15.2478 281.672L35.9827 293.758L37.997 290.302Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5269 291.743L18.7036 283.686L16.6893 287.142L30.5126 295.199L32.5269 291.743Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7152 263.524L22.4361 253.453L20.4218 256.908L37.7009 266.98L39.7152 263.524Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1567 268.994L20.4218 256.909L18.4075 260.365L39.1424 272.45L41.1567 268.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1424 272.45L21.8633 262.378L19.8491 265.834L37.1282 275.906L39.1424 272.45Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9059 277.624L53.5385 271.581L49.5099 278.493L59.8773 284.536L63.9059 277.624Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8773 284.535L52.9657 280.507L50.9514 283.963L57.8631 287.991L59.8773 284.535Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4072 285.977L44.0398 279.935L42.0255 283.39L52.393 289.433L54.4072 285.977Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9372 287.419L38.5697 281.376L36.5554 284.832L46.9229 290.875L48.9372 287.419Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M43.4476 233.291L39.9918 231.276L37.9775 234.732L41.4334 236.746L43.4476 233.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M44.8892 238.761L41.4333 236.747L39.4191 240.202L42.8749 242.217L44.8892 238.761Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1007_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.264 80.1304L120.224 72.5435L118.296 70.2665L109.336 77.8534L111.264 80.1304Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.096 79.75L120.536 68.3696L118.608 66.0927L105.168 77.4731L107.096 79.75Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.928 79.3696L120.848 64.1958L118.92 61.9189L101 77.0927L102.928 79.3696Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7604 78.9898L121.16 60.0225L119.232 57.7455L96.8324 76.7128L98.7604 78.9898Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5925 78.6094L121.472 55.8486L119.544 53.5717L92.6644 76.3325L94.5925 78.6094Z",
    fill: "#228B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6644 76.3325L119.544 53.5718L117.616 51.2948L90.7363 74.0556L92.6644 76.3325Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4963 75.9522L119.856 49.3979L117.928 47.121L86.5683 73.6752L88.4963 75.9522Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5684 73.6753L117.928 47.1211L114.072 42.5672L82.7123 69.1215L86.5684 73.6753Z",
    fill: "#32CD32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7123 69.1216L114.072 42.5674L112.144 40.2905L80.7842 66.8447L82.7123 69.1216Z",
    fill: "#4DE94D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.128 69.886L116.368 67.9893L114.44 65.7123L112.2 67.6091L114.128 69.886Z",
    fill: "#5EFF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.2 67.6094L116.68 63.8159L114.752 61.539L110.272 65.3324L112.2 67.6094Z",
    fill: "#5EFF5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.272 65.3323L116.992 59.6421L115.064 57.3652L108.344 63.0554L110.272 65.3323Z",
    fill: "#70FF70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.344 63.0552L117.304 55.4683L115.376 53.1913L106.416 60.7783L108.344 63.0552Z",
    fill: "#8FFF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.176 62.6751L115.376 53.1914L113.448 50.9145L102.248 60.3981L104.176 62.6751Z",
    fill: "#AAFFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6644 76.3323L99.3843 70.6421L97.4562 68.3652L90.7364 74.0554L92.6644 76.3323Z",
    fill: "#1A7A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4964 75.9524L95.2163 70.2622L93.2883 67.9853L86.5684 73.6755L88.4964 75.9524Z",
    fill: "#1A7A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5684 73.6753L91.0483 69.8818L87.1923 65.328L82.7124 69.1214L86.5684 73.6753Z",
    fill: "#0F6B0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7843 66.8447L112.144 40.2905L110.216 38.0136L78.8563 64.5678L80.7843 66.8447Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0242 64.9483L109.904 42.1875L107.976 39.9106L81.0962 62.6713L83.0242 64.9483Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2642 63.0513L107.664 44.084L105.736 41.8071L83.3361 60.7744L85.2642 63.0513Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8562 64.5679L110.216 38.0137L108.288 35.7367L76.9282 62.291L78.8562 64.5679Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9282 62.291L108.288 35.7368L104.432 31.183L73.0722 57.7372L76.9282 62.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0721 57.7373L104.432 31.1831L102.504 28.9062L71.1441 55.4604L73.0721 57.7373Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3841 53.5635L100.264 30.8027L98.3356 28.5258L71.4561 51.2866L73.3841 53.5635Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6959 49.3897L96.0956 30.4224L94.1676 28.1454L71.7679 47.1127L73.6959 49.3897Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0079 45.2163L91.9276 30.0425L89.9996 27.7656L72.0799 42.9394L74.0079 45.2163Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3199 41.0425L87.7596 29.6621L85.8316 27.3852L72.3918 38.7656L74.3199 41.0425Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6318 36.8687L83.5917 29.2817L81.6636 27.0048L72.7038 34.5917L74.6318 36.8687Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6079 49.0139L103.808 39.5303L101.88 37.2533L90.6799 46.737L92.6079 49.0139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.44 48.6338L101.88 37.2534L99.9517 34.9765L86.5119 46.3569L88.44 48.6338Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5118 46.3567L97.7117 36.873L95.7836 34.5961L84.5838 44.0798L86.5118 46.3567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9282 62.2908L83.6481 56.6006L79.792 52.0467L73.0721 57.7369L76.9282 62.2908Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0721 57.7373L77.552 53.9438L75.624 51.6669L71.144 55.4604L73.0721 57.7373Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.384 53.5632L80.1039 47.873L78.1759 45.5961L71.456 51.2863L73.384 53.5632Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.696 49.3899L80.4159 43.6997L78.4879 41.4228L71.768 47.113L73.696 49.3899Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M112.824 59.262L115.064 57.3652L113.136 55.0883L110.896 56.985L112.824 59.262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M108.656 58.8816L110.896 56.9849L108.968 54.7079L106.728 56.6047L108.656 58.8816Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_1007_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.101 48.9862L249.392 63.105L252.88 67.4794L270.588 53.3607L267.101 48.9862Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.016 49.8311L248.453 71.0093L251.941 75.3837L278.503 54.2056L275.016 49.8311Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93 50.6756L247.513 78.9131L251.001 83.2876L286.418 55.05L282.93 50.6756Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.845 51.5205L246.574 86.8174L250.062 91.1918L294.333 55.8949L290.845 51.5205Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.76 52.3654L245.635 94.7217L249.122 99.0961L302.248 56.7399L298.76 52.3654Z",
    fill: "#2C4FB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.248 56.7399L249.122 99.0962L252.61 103.471L305.735 61.1144L302.248 56.7399Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.163 57.5843L248.183 107L251.671 111.374L313.65 61.9588L310.163 57.5843Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65 61.9588L251.671 111.375L258.646 120.123L320.626 70.7078L313.65 61.9588Z",
    fill: "#4169E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.626 70.7079L258.646 120.124L262.134 124.498L324.113 75.0823L320.626 70.7079Z",
    fill: "#5577E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.795 68.3243L256.368 71.854L259.855 76.2285L264.283 72.6988L260.795 68.3243Z",
    fill: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.283 72.6989L255.428 79.7583L258.916 84.1328L267.77 77.0734L264.283 72.6989Z",
    fill: "#6A8AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.77 77.073L254.489 87.6621L257.977 92.0366L271.258 81.4475L267.77 77.073Z",
    fill: "#7A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.258 81.4476L253.55 95.5664L257.037 99.9409L274.746 85.8221L271.258 81.4476Z",
    fill: "#8AABFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.173 82.2925L257.037 99.9409L260.525 104.315L282.66 86.6669L279.173 82.2925Z",
    fill: "#9ABBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.248 56.7395L288.966 67.3286L292.454 71.7031L305.735 61.114L302.248 56.7395Z",
    fill: "#2040A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.163 57.5848L296.881 68.1738L300.369 72.5483L313.65 61.9592L310.163 57.5848Z",
    fill: "#2040A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65 61.9592L304.796 69.0186L311.771 77.7675L320.626 70.7081L313.65 61.9592Z",
    fill: "#1A3590"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.113 75.0824L262.134 124.498L265.622 128.873L327.601 79.4568L324.113 75.0824Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.686 78.612L266.561 120.968L270.049 125.343L323.174 82.9864L319.686 78.612Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.259 82.1416L270.988 117.438L274.476 121.813L318.747 86.516L315.259 82.1416Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.601 79.4569L265.622 128.873L269.109 133.247L331.089 83.8314L327.601 79.4569Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.089 83.8314L269.109 133.247L276.085 141.996L338.064 92.5803L331.089 83.8314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.064 92.5804L276.085 141.996L279.573 146.371L341.552 96.9549L338.064 92.5804Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.125 100.485L284 142.841L287.487 147.215L340.613 104.859L337.125 100.485Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 108.389L291.915 143.686L295.402 148.06L339.673 112.763L336.186 108.389Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.246 116.293L299.829 144.53L303.317 148.905L338.734 120.667L335.246 116.293Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.307 124.197L307.744 145.375L311.232 149.749L337.795 128.571L334.307 124.197Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.367 132.101L315.659 146.22L319.147 150.594L336.855 136.475L333.367 132.101Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.099 108.539L277.964 126.188L281.451 130.562L303.587 112.914L300.099 108.539Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.014 109.384L281.451 130.562L284.939 134.936L311.502 113.758L308.014 109.384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.502 113.758L289.366 131.407L292.854 135.781L314.989 118.133L311.502 113.758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.089 83.8313L317.808 94.4204L324.783 103.169L338.064 92.5803L331.089 83.8313Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.064 92.5803L329.21 99.6396L332.698 104.014L341.552 96.9547L338.064 92.5803Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.125 100.485L323.844 111.074L327.331 115.448L340.613 104.859L337.125 100.485Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.186 108.388L322.904 118.978L326.392 123.352L339.673 112.763L336.186 108.388Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M262.404 88.5074L257.977 92.0371L261.464 96.4116L265.892 92.8819L262.404 88.5074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M270.319 89.3521L265.891 92.8818L269.379 97.2563L273.806 93.7266L270.319 89.3521Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_1007_1018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.845 326.954L237.685 332.676L239.267 330.784L232.427 325.062L230.845 326.954Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.717 323.632L240.977 332.215L242.56 330.323L232.3 321.74L230.717 323.632Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.59 320.31L244.27 331.753L245.852 329.862L232.172 318.418L230.59 320.31Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.462 316.988L247.562 331.292L249.145 329.4L232.045 315.096L230.462 316.988Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.335 313.665L250.854 330.831L252.437 328.939L231.917 311.774L230.335 313.665Z",
    fill: "#CCAC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.917 311.774L252.437 328.939L254.02 327.047L233.5 309.882L231.917 311.774Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79 308.451L255.729 328.478L257.312 326.586L233.373 306.56L231.79 308.451Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.373 306.56L257.312 326.586L260.477 322.802L236.538 302.776L233.373 306.56Z",
    fill: "#FFD700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.538 302.776L260.477 322.802L262.06 320.91L238.12 300.884L236.538 302.776Z",
    fill: "#FFE44D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14 327.462L240.85 328.893L242.432 327.001L240.722 325.57L239.14 327.462Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.722 325.57L244.142 328.431L245.725 326.539L242.305 323.679L240.722 325.57Z",
    fill: "#FFED4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.305 323.678L247.435 327.97L249.017 326.078L243.887 321.787L242.305 323.678Z",
    fill: "#FFF266"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.887 321.787L250.727 327.508L252.31 325.617L245.47 319.895L243.887 321.787Z",
    fill: "#FFF68F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.76 318.465L252.31 325.617L253.892 323.725L245.342 316.573L243.76 318.465Z",
    fill: "#FFFAAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.917 311.774L237.047 316.065L238.63 314.173L233.5 309.882L231.917 311.774Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79 308.451L236.92 312.743L238.502 310.851L233.373 306.56L231.79 308.451Z",
    fill: "#DDB900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.373 306.56L236.792 309.42L239.958 305.637L236.538 302.776L233.373 306.56Z",
    fill: "#CCAA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12 300.884L262.06 320.91L263.642 319.018L239.703 298.992L238.12 300.884Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83 302.314L260.35 319.479L261.932 317.588L241.413 300.423L239.83 302.314Z",
    fill: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.54 303.745L258.64 318.049L260.222 316.158L243.123 301.853L241.54 303.745Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.703 298.992L263.642 319.019L265.225 317.127L241.285 297.101L239.703 298.992Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.285 297.101L265.225 317.127L268.39 313.343L244.45 293.317L241.285 297.101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45 293.317L268.39 313.343L269.972 311.451L246.033 291.425L244.45 293.317Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.743 292.856L268.262 310.021L269.845 308.129L249.325 290.964L247.743 292.856Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.035 292.394L268.135 306.699L269.717 304.807L252.618 290.503L251.035 292.394Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.328 291.933L268.007 303.376L269.59 301.485L255.91 290.041L254.328 291.933Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62 291.472L267.88 300.055L269.462 298.163L259.203 289.58L257.62 291.472Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.913 291.011L267.752 296.732L269.335 294.841L262.495 289.119L260.913 291.011Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.255 307.114L261.805 314.266L263.387 312.374L254.837 305.222L253.255 307.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.127 303.791L263.387 312.374L264.97 310.482L254.71 301.9L253.127 303.791Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.71 301.9L263.26 309.052L264.842 307.16L256.292 300.008L254.71 301.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.285 297.101L246.415 301.392L249.58 297.609L244.45 293.317L241.285 297.101Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.45 293.317L247.87 296.178L249.453 294.286L246.033 291.426L244.45 293.317Z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.743 292.856L252.873 297.147L254.455 295.255L249.325 290.964L247.743 292.856Z",
    fill: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.035 292.395L256.165 296.686L257.748 294.794L252.618 290.503L251.035 292.395Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M247.307 324.648L249.017 326.078L250.6 324.186L248.89 322.756L247.307 324.648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M247.18 321.325L248.89 322.756L250.472 320.864L248.762 319.434L247.18 321.325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1007_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 487,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1007_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 100,
    fill: "white",
    transform: "translate(33.3569 195) rotate(30.2365)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1007_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.7027,
    height: 74.5893,
    fill: "white",
    transform: "translate(142 61.9233) rotate(139.743)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_1007_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.24,
    height: 139.866,
    fill: "white",
    transform: "translate(207 82.5938) rotate(-38.565)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_1007_1018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.5875,
    height: 61.66,
    fill: "white",
    transform: "translate(248.199 347.903) rotate(-140.087)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGachaMachine);
export default __webpack_public_path__ + "static/media/gacha-machine.01ef597a8ac16974448ef27345529064.svg";
export { ForwardRef as ReactComponent };